import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { QueryClient, useQuery } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const queryClient = new QueryClient();

const localStoragePersister = createSyncStoragePersister({
    storage: window.localStorage,
});
persistQueryClient({
    queryClient,
    persister: localStoragePersister,
});


// Custom hook for fetching data with centralized loading, error handling, and i18n support
export function useFetch(queryKey, fetchFunction, options = {}) {
    const { i18n } = useTranslation(); // Access i18n for language changes

    // Refetch data automatically when the language changes
    useEffect(() => {
        queryClient.invalidateQueries(queryKey); // Invalidate cache to refetch data
    }, [i18n.language]); // Dependency on language change


    // Use React Query's `useQuery` with persistence and i18n integration
    const queryResult = useQuery({
        queryKey,
        queryFn: async () => {
            return fetchFunction(i18n.language);
        },
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 5 * 60 * 1000, // Optional: fine-tune per-query staleTime
    });

    return queryResult;
}